// Tracking Manifest
// https://docs.google.com/spreadsheets/d/1iV3zddQLB-tSgnZrn2Dn3zBHB0DOmsYzh58-3-xW7go/edit#gid=1785175273

export const enum TrackingEvent {
	// ONBOARDING EVENTS
	ONBOARDING_ACCOUNT_DETAILS = 'Onboarding Account details',
	ONBOARDING_TEMPLATE = 'Onboarding Template',
	ONBOARDING_START = 'Onboarding Start',
	ONBOARDING_SOURCE_CHOSEN = 'Onboarding Source chosen',
	ONBOARDING_METRICS_CHOSEN = 'Onboarding Metrics chosen',
	ONBOARDING_CONNECT_CONNECT = 'Onboarding Connect connect',
	ONBOARDING_CONNECT_SUCCESS = 'Onboarding Connect success',
	ONBOARDING_ALL_SET = 'Onboarding All set',
	ONBOARDING_SKIPPED = 'Onboarding skipped',
	ONBOARDING_SOURCE = 'Onboarding Source',
	ONBOARDING_SAMPLE_DATA_CONFIRMED = 'Onboarding sample data confirmed',
	ONBOARDING_METADATA_COMPLETED = 'Onboarding metadata completed',

	// GUIDED ONBOARDING EVENTS
	GUIDED_ONBOARDING_TOUR_START = 'Guided onboarding tour start', // origin = 'home'
	GUIDED_ONBOARDING_TOUR_STEP_COMPLETED = 'Guided onboarding tour step completed', // level = 'step_1' | 'step_2' | 'step_3' | 'completed'

	// DATABOARD WIZARD EVENTS

	// TEMPLATE ONBOARDING EVENTS
	TEMPLATE_ONBOARDING_EDIT = 'Template Onboarding edit',
	TEMPLATE_ONBOARDING_CHOICE_SHOWN = 'Template Onboarding choice shown',
	TEMPLATE_ONBOARDING_CHOICE_COMPLETED = 'Template Onboarding choice completed',
	TEMPLATE_ONBOARDING_CHOICE_SKIPPED = 'Template Onboarding choice skipped',
	PROMOTE_SCHEDULED_SNAPSHOT_TEMPLATE = 'Promote Scheduled Snapshot Template',

	// DESIGNER
	DESIGNER_PRIMARY_VIEW_CHANGED = 'Designer primary view changed', // view = 'desktop' | 'mobile'
	DESIGNER_COLOR_CHANGE = 'Designer color change',
	DESIGNER_THEME_CHANGE = 'Designer theme change',
	DESIGNER_LOOP_ADD = 'Designer loop add',
	DESIGNER_REPORT_ADD = 'Designer report add',
	DATABOARD_VISUAL_SETTINGS_MODIFIED = 'Databoard Visual settings modified',
	DATABOARD_SHARE_POPUP_OPEN = 'Databoard Share popup open',
	DATABLOCK_DROP = 'Datablock drop',
	BLOCK_PROPERTIES_METRIC_SELECTED = 'Block properties metric selected',
	DESIGNER_ADVANCED_POPUP = 'Designer Advanced popup',
	DESIGNER_ADVANCED_POPUP_EDIT = 'Designer Advanced popup edit',
	BLOCK_VISUALIZATION_CHANGED = 'Block visualization changed',
	BLOCK_PROPERTIES_SETTINGS_CHANGED = 'Block properties settings changed',
	BLOCK_PROPERTIES_METRIC_SETTINGS_CHANGED = 'Block properties metric settings changed',

	// TAGS
	TAGS_CREATED_NEW = 'Tags created new',

	// DATABOARDS
	DATABOARD_SHOW_PREVIEW = 'Datawall show preview',
	DATABOARD_CREATED_NEW = 'Databoard create new', // origin = 'designer' | 'wizard' | 'greenplus' | 'public_template';
	DATABOARD_CREATED = 'Databoard Created', // from = 'designer' | 'metric' | 'wizard_metrics' | 'transfered_board' | 'transfered_report' | 'report_public_template' | 'report_account_template' | 'recommended_templates', datasources = [SourceTypeKeys]
	DATABOARD_DELETE = 'Databoard delete', // origin = 'home' | 'databoards' | 'designer', databoard_id = number
	FAVORITE_BOARD_ADDED = 'Favorite board added', // TrackingOriginForFavoriteBoardAdded
	DATABOARD_DUPLICATE = 'Databoard duplicate', // TrackingOriginForDataboardDuplicate
	SHARE_INTERNAL_URL_BY_COPY_PASTE = 'Share internal url by copy/paste',
	SHARE_PUBLIC_URL_BY_COPY_PASTE = 'Share public url by copy/paste',
	SHARE_PUBLIC_URL_BY_EMBED = 'Share public url by embed',
	SHARE_NEW_SNAPSHOT = 'Share new snapshot',
	SHARE_SNAPSHOT_NOW = 'Share snapshot now',
	DATABOARD_VISUAL_SETTINGS_OPEN = 'Databoard Visual settings open',
	PROMOTE_SCHEDULED_SNAPSHOT = 'Promote Scheduled Snapshot',
	PROMOTE_SCHEDULED_SNAPSHOT_FREE = 'Promote Scheduled Snapshot Free',
	DATABOARD_DOWNLOADED = 'Databoard downloaded', // origin = 'designer', format = 'jpg', type = 'databoard'
	DATABOARD_RENAME = 'Databoard rename',
	DATABOARD_EDIT = 'Databoard edit',

	// METRICS
	METRIC_ADDED_TO_BOARD = 'Metric added to board',

	// SCRIPTS & QUERIES
	NEW_CUSTOM_METRIC = 'New custom metric',
	NEW_CALCULATION = 'New calculation',
	CALCULATION_CREATED = 'Calculation created',
	NEW_QUERY = 'New query', // origin =
	QUERY_CREATED = 'Query created', // type = 'sheets_wizard' | 'custom_API_wizard' | 'standard'
	QUERY_EDITED = 'Query edited', // type = 'sheets_wizard' | 'custom_API_wizard' | 'standard'
	QUERY_SOURCE_SELECTED = 'Query source selected', // datasource = sourceType.key
	QUERY_CREATE_WIZARD_STARTED = 'Query create wizard started', // origin = , type = sheets_wizard | custom_API_wizard
	QUERY_SHEETS_VIDEO_SEEN = 'Query Builder video seen', // origin =  'onboarding' | 'designer' | 'sheets_wizard'
	QUERY_SWITCH_TO_WIZARD = 'Query Wizard Switch to wizard', // type = 'sheets_wizard' | 'custom_API_wizard'
	QUERY_SWITCH_TO_MANUAL = 'Query Wizard Switch to manual', // type = 'sheets_wizard' | 'custom_API_wizard'

	// DATA MANAGER
	NEW_CONNECTION = 'New connection',
	CONNECT_SELECTED_INTEGRATIONS_POPUP_SHOWN = 'Connect selected integrations popup shown',
	DATA_PRIORITY_UPDATE_POPUP_OPENED = 'Data priority update popup opened',

	// PUBLIC TEMPLATES

	// ACCOUNT TEMPLATES
	NEW_ACCOUNT_TEMPLATE = 'New account template',
	TEMPLATE_CREATED = 'Template created', // TrackingOriginForTemplateCreated
	TEMPLATE_EDIT = 'Template edit',
	TEMPLATE_EDITED = 'Template edited',
	TEMPLATE_DELETED = 'Template deleted',
	TEMPLATE_PREVIEW = 'Preview a template',
	USE_A_TEMPLATE = 'Use a template',
	TEMPLATE_USED = 'Template Used',
	TEMPLATE_DATABOARDS_UPDATE_POPUP = 'Update template databoards popup',
	TEMPLATE_DATABOARDS_UPDATED = 'Template databoards updated',

	// NOTIFICATIONS
	NEW_ALERT = 'New alert',
	ALERT_CREATED = 'Alert created',
	ALERT_MODIFIED = 'Alert modified',
	NEW_SCORECARD = 'New scorecard',
	SCORECARD_CREATED = 'Scorecard created',
	SCORECARD_MODIFIED = 'Scorecard modified',
	SCORECARD_DELETED = 'Scorecard deleted',

	// ACCOUNT
	SELECT_INTEGRATION_POPUP_SHOWN = 'Select Integration popup shown',
	SELECT_INTEGRATION_POPUP_COMPLETED = 'Select Integration popup completed',
	FEATURES_POPUP_SHOWN = 'Promote features popup shown', // choices: FeatureType = 'data_sources' | 'boards' | 'clients' | 'reports' | 'board_loops' | 'custom_metrics' | 'metric_calculations' | 'scorecards' | 'alerts' | 'board_shares' | 'metric_digests' | 'goals' | 'white_labeling'
	FEATURES_POPUP_COMPLETED = 'Promote features popup completed', // choice: FeatureType = 'data_sources' | 'boards' | 'clients' | 'reports' | 'board_loops' | 'custom_metrics' | 'metric_calculations' | 'scorecards' | 'alerts' | 'board_shares' | 'metric_digests' | 'goals' | 'white_labeling'

	// USER MANAGEMENT
	NEW_USER = 'New user',
	NEW_USER_ADDED = 'New user added',

	// CLIENT MANAGEMENT
	CLIENT_DELETED = 'Client deleted',

	// BILLING
	LIMITATION_POPUP = 'Limitation popup',
	TRIAL_POPUP_OPENED = 'Trial popup opened',
	ADDON_PURCHASE_POPUP_OPENED = 'Add-on purchase popup opened',
	ADD_CREDITS_POPUP_OPENED = 'Add credits popup opened',
	ADD_CREDITS_POPUP_COMPLETED = 'Add credits popup completed',
	ADD_PACKS_POPUP_OPENED = 'Add packs popup opened',
	ADD_PACKS_POPUP_COMPLETED = 'Add packs popup completed',
	CHANGE_BILLING_PERIOD = 'Change billing period',
	UNSUBSCRIBE_FEEDBACK = 'Unsubscribe feedback',
	PLAN_CHANGE = 'Plan change',
	PAYMENT_DETAILS_POPUP_SHOWN = 'Payment Details popup shown',
	ANNUAL_BANNER_SHOWN = 'Annual banner shown',
	ANNUAL_BANNER_SKIPPED = 'Annual banner skipped',
	CARD_EXPIRING_POPUP_SHOWN = 'Card expired popup shown',
	CARD_EXPIRING_POPUP_SHOWN_DONE = 'Card expired popup completed',
	UPGRADE_INITIATED = 'Upgrade initiated',
	SUBSCRIPTION_CHANGE_POPUP = 'Subscription change popup',
	UPGRADE_INVITE_SENT = 'Upgrade invite sent',
	AGENCY_LIMITATION_HIT_POPUP_SHOWN = 'Agency limitations hit popup shown',
	AGENCY_DOWNGRADE_POPUP_SHOWN = 'Agency downgrade popup shown',

	// NOTIFICATIONS
	NEW_NOTIFICATION = 'New notification',

	// AGENCY CLIENTS
	NEW_CLIENT_FORM = 'New client form', // TrackingOriginTypeForNewClientForm
	SWITCH_ACCOUNT = 'Switch account', // origin = 'popup' | 'list'

	// OTHER
	EMAIL_CLICKED = 'Email clicked',
	INTEGRATION_POPUP_OPENED = 'Integration popup opened',
	NEW_CONNECTION_ADDED = 'New connection added',
	NEW_CONNECTION_INITIATED = 'New connection initiated',
	NEW_TOKEN_CREATED = 'New token created',
	NEW_CONNECTION_ADDED_CHOICE_POPUP = 'New connection added choice popup',
	FILE_REUPLOADED = 'File re-uploaded',
	CALL_INITIATED = 'Call initiated', // origin = 'expired_popup_trial_extension' | 'top_banner_free_setup_help' | 'billing_page_cta' | 'billing_page_text' | 'help_free' | 'help_paid' | 'top_banner_trial_setup_help' | 'top_banner_ending_trial_extension' | 'top_banner_expired_trial_extension' | 'forecasting_trial' | 'cancellation' | 'cancellation_offer' | 'cancellation_review_only' | 'genie_side_panel' | 'genie'
	CHAT_INITIATED = 'Chat initiated', // origin = 'billing_page_cta' | 'help_free' | 'help_paid'
	TRIAL_EXPIRED_POPUP_SHOWN = 'Trial expired popup shown',
	NPS_SHOWN = 'NPS shown',
	NPS_SCORE_COMPLETED = 'NPS score completed',
	NPS_FEEDBACK_COMPLETED = 'NPS feedback completed',
	NPS_BOOK_A_CALL = 'NPS book a call',
	NPS_SKIPPED = 'NPS skipped',
	NPS_FEEDBACK_CTA_CLICKED = 'NPS feedback CTA clicked',
	WL_POPUP_SHOWN = 'WL popup shown',
	WL_POPUP_COMPLETED = 'WL popup completed', // choice = 'start' | 'help'
	PLAN_TRIAL_POPUP_OPENED = 'Plan Trial popup opened', // feature, current_plan_id
	ISSUE = 'Issue', // type, feature, page, url, duration, http_status_code, error_message, endpoint
	ISSUE_REPORTED = 'Issue Reported',
	AI_SUMMARY_EDITED = 'AI summary edited',
	PRODUCT_UPDATES_POPUP_SHOWN = 'Product updates popup shown',
	PRODUCT_UPDATES_POPUP_CLOSED = 'Product updates popup closed',
	PRODUCT_UPDATES_CLICKED = 'Product updates clicked', // origin = 'see_all', 'read_more'
	INSIGHTS_ACTIVITY_MESSAGE_ACTION = 'Insights activity message action',
	RESELLER_PROMO_CLICKED = 'Reseller promo clicked', // origin = 'billing_page_tile' | 'client_page_banner'
	DATABLOCK_EXPLORE = 'Datablock explore', // origin = TrackingOriginTypeForDatablockExplore
	DATABLOCK_DUPLICATE = 'Datablock duplicate', // origin = TrackingOriginTypeForDatablockDuplicate
	DATABLOCK_SAVED = 'Datablock changes saved', // origin = TrackingOriginTypeForDatablockExplore ("databoard" for now)
	GENIE_INTRO_MODAL_SHOWN = 'Genie intro modal shown',
	GENIE_INTRO_MODAL_CTA_CLICKED = 'Genie intro modal CTA clicked',
	AI_WELCOME_SCREEN_MODAL_SEEN = 'AIWelcome screen modal seen',
	AI_WELCOME_SCREEN_MODAL_CTA_CLICKED = 'AIWelcome screen modal cta clicked', // action = close | genie | schedule
	GENIE_ARTIFACTS_MODAL_SHOWN = 'Genie artifacts modal shown',
	GENIE_ARTIFACTS_MODAL_CTA_CLICKED = 'Genie artifacts modal CTA clicked',
	NEW_NAVIGATION_INTRO_MODAL_SHOWN = 'New navigation intro modal shown',
	NEW_NAVIGATION_INTRO_MODAL_CTA_CLICKED = 'New navigation intro modal CTA clicked',

	// GOALS
	NEW_GOAL = 'New goal',
	GOAL_EDITED = 'Goal edited',
	GOAL_CREATED = 'Goal created',
	GOAL_RENAME = 'Goal rename',
	GOAL_INSIGHTS_OPEN = 'Goal insights open',
	GOAL_TIMETABLE_OPEN = 'Goal timetable open',
	GOAL_TIMETABLE_CHANGED = 'Goal timetable changed',
	GOAL_CALCULATION_STRATEGY_CHANGED = 'Goal calculation strategy changed',
	GOAL_FAVORITED = 'Favorite goal added',
	GOAL_PERMISSIONS_POPUP = 'Goal permissions popup',
	GOAL_PROGRESS_UPDATED = 'Goal progress updated',
	GOAL_PROGRESS_EDITED = 'Goal progress edited',

	// FORECASTS
	FORECAST_SAVED = 'Forecast saved',
	FORECAST_REMOVED = 'Forecast removed',
	FORECASTS_REORDER = 'Forecasts reorder',
	FORECAST_DETAILS_VIEWED = 'Forecast details viewed',

	// CLIENT KPIs

	// ACCOUNT PROGRESS
	ACCOUNT_PROGRESS_STEP_CLICK = 'Account progress step click',

	// WIZARD POPUPS
	FIRST_WIZARD_SHOWN = 'First wizard shown',
	FIRST_WIZARD_COMPLETED = 'First wizard completed',
	FIRST_WIZARD_SKIPPED = 'First wizard skipped',

	// DATE RANGES
	DATE_RANGE_CHANGED = 'Date range changed', // origin = 'datablock_designer' | 'datablock_editor' | 'datablock_settings_designer' | 'datablock_settings_editor' | 'goals' | 'datablock_explorer' | 'metrics_detail' | 'forecast'
	DATE_RANGE_DROPDOWN_OPENED = 'Date range dropdown opened', // origin = 'datablock_explorer'
	GRANULATION_CHANGED = 'Granulation change',
	GRANULATION_DROPDOWN_OPENED = 'Granulation dropdown opened',
	COMPARE_DROPDOWN_OPENED = 'Compare dropdown opened',

	// FILTERING (MDSPLIT)
	FILTER_DATA_SET = 'Filter data set', // origin = 'block' | 'master' | 'datablock_explorer' |'designer' (designer = only adv filtering) | 'metrics_detail' | 'forecast'
	FILTER_DATA_ADDED = 'Filter data added', // (only adv filtering)
	FILTER_DATA_REMOVED = 'Filter data removed', // (only adv filtering)

	// DATA STATUS

	// DATABOARD
	BOARD_REFRESH_DATA = 'Refresh data',

	// DATABOARD LOOPS
	LOOP_NEW = 'Loop new',
	LOOP_CREATED = 'Loop created', // origin = 'designer' | 'designer_bar' | '<genie origin>_AIchat' | 'genie'
	LOOP_EDITED = 'Loop edited', // origin = 'designer' | 'designer_bar'
	ADD_TO_LOOP = 'Add to loop', // origin = '<genie origin>_AIchat' | 'genie' | standard origins
	LOOP_EDIT_POPUP_OPEN = 'Loop edit popup open',
	LOOP_DUPLICATE = 'Loop duplicate',
	LOOP_FAVORITED = 'Favorite loop added',

	// REPORTS
	REPORT_NEW = 'Report new', // origin = 'page' | 'home' | 'databoards' | 'designer' | 'reports' | 'loops' | 'transfered_report' | 'report_public_template' | 'report_account_template'
	REPORT_CREATED = 'Report created', // origin = 'page' | 'home' | 'databoards' | 'designer' | 'reports' | 'loops' | 'transfered_report' | 'report_public_template' | 'report_account_template'
	REPORT_CREATE_MODAL_SHOWN = 'Report create modal shown', // origin = 'reports_new' | 'reports' | 'listing' | 'empty_screen'
	REPORT_CREATE_MODAL_CHOICE = 'Report create modal choice', // choice = 'ai' | 'template' | 'blank', origin
	REPORT_EDITED = 'Report edited', // origin = 'page' | 'reports' | 'editor'
	REPORT_SEND = 'Report send',
	SCHEDULED_REPORT_SENT = 'Scheduled Report sent',
	REPORT_SHARE_POPUP_OPEN = 'Report share popup open',
	REPORT_REMINDER = 'Report reminder',
	REPORT_DELETED = 'Report deleted',
	REPORT_METRIC_STORY_ADD = 'New data story added',
	REPORT_FAVORITED = 'Report favorited',
	PRESENT_SLIDE = 'Present slide', // origin = 'reports' | 'reports_preview' | 'editor' | 'reports_public_URL'
	NEW_SLIDE_ADDED = 'New slide added',
	SWITCH_REPORT_FORMAT = 'Switch report format', // origin = 'editor', type: 'pageless' | 'slides'

	// DESIGNER
	DESIGNER_BLOCK_NAME = 'Designer block name', // origin = 'datablock_designer' | 'datablock_editor' | 'datablock_settings_designer' | 'datablock_settings_editor'
	DESIGNER_COMPARE_CHOSEN = 'Designer compare chosen',

	// METRIC INSIGHTS
	METRIC_INSIGHTS_VIEWED = 'Metric details viewed', // origin = 'metrics_detail' | 'home_trends' | 'home_metrics' | 'summary'
	METRIC_INSIGHTS_POPUP = 'Metric insights popup', // origin = 'databoards' | 'datablock_explorer' | 'report' | 'home_metrics' | 'home_trends' | 'metrics' | 'teams' | 'allmetrics'
	METRIC_DETAILS_SIDE_BAR_CHANGED = 'Metric details side-bar changed',
	METRIC_DETAILS_METRIC_CHANGED = 'Metric details metric changed', // origin = 'metrics_detail' | 'forecast'
	METRIC_DETAILS_URL_COPIED = 'Metric details URL copied', // origin = 'metrics_detail' | 'forecast'
	METRIC_DETAILS_BREAKDOWN_BY = 'Metric details breakdown by', // origin = 'metrics_detail' | 'forecast'
	METRIC_DETAILS_CUMULATIVE_ON = 'Metric details cumulative on', // origin = 'metrics_detail'
	METRIC_DETAILS_CUMULATIVE_OFF = 'Metric details cumulative off', // origin = 'metrics_detail'

	// ANOMALY DETECTION
	ANOMALIES_HIGHLIGHTED = 'Anomalies highlighted',
	ANOMALY_DETECTION_ERROR = 'Anomaly detection error',
	ANOMALY_DETECTION_PARAMETERS_CHANGED = 'Anomaly detection parameters changed',

	// METRIC DIGEST
	METRIC_DIGEST_CREATED = 'Metric digest created',
	METRIC_DIGEST_EDITED = 'Metric digest edited',
	METRIC_DIGEST_DELETED = 'Metric digest deleted',
	METRIC_DIGEST_NEW = 'Metric digest new',
	METRIC_DIGEST_STATUS_CHANGE = 'Metric digest status change',

	// CANCELATION FLOW
	CANCELATION_FLOW_STARTED = 'Cancellation flow started', // TrackingOriginForCancellationFlowStarted
	CANCEL_INITATED = 'Cancel initiated',
	CANCEL_SUBSCRIPTION_INITIAL = 'Cancel subscription initial',
	CANCEL_SUBSCRIPTION = 'Cancel subscription',

	CANCELLATION_OFFER_SHOWN = 'Cancellation offer shown', // choices: BillingCancellationOptionType = 'support' | 'cancel'
	CANCELLATION_OFFER_COMPLETED = 'Cancellation offer completed', // choice: BillingCancellationOptionType = 'support' | 'cancel', feedback_choice: popup-feedback/mainChoices/label

	// FORECASTING
	FORECASTING_METRIC_SELECTED = 'Forecasting metric selected',
	FORECASTING_IMPACTING_METRIC_ADDED = 'Forecasting impacting metric added',
	FORECASTING_ERROR = 'Forecasting error',
	FORECAST_RECALCULATE = 'Forecast recalculate',

	// PERFORMANCE SCREEN
	PERFORMANCE_SCREEN_ADDED_METRIC = 'Home metric added',
	PERFORMANCE_SCREEN_ADDED_GOAL = 'Home goal added',

	// ACTIVITY LOG
	ACTIVITY_LOG_LOCKED = 'Activity log locked',
	ACTIVITY_LOG_POPUP = 'Activity log popup',

	// SERVICES AND ADDONS POPUP
	SERVICES_AND_ADDON_POPUP_SERVICE_STEP_DONE = 'Service options popup completed',
	SERVICES_AND_ADDON_POPUP_ADDONS_STEP_DONE = 'Add-on options popup completed',
	SERVICES_AND_ADDON_POPUP_SUMMARY_STEP_DONE = 'Add-on service popup purchased',

	// DEMO ACCOUNT
	DEMO_OPENED = 'Demo opened',
	DEMO_BACK_TO_ANALYTICS = 'Demo back to analytics',
	DEMO_CREATE_ACCOUNT = 'Demo create account',
	DEMO_LOGIN = 'Demo login',

	// PROMOS
	INVITE_USER_PROMO_SHOWN = 'Promote add users popup shown',
	LOOP_PROMO_SHOWN = 'Databoard loop popup shown',
	PROMOTE_PLAN_POPUP_SHOWN = 'Promote plan popup shown',
	CUSTOM_CALCULATED_METRIC_PROMO_SHOWN = 'Recommended custom metrics popup shown',

	// SMART ALERTS
	SMART_ALERTS_ENABLED = 'Smart alerts enabled',
	SMART_ALERTS_DISABLED = 'Smart alerts disabled',
	SMART_ALERTS_SETTINGS_CHANGED = 'Smart alerts settings changed',
	SMART_ALERTS_ANOMALY_DELETED = 'Anomaly deleted',

	// TEAMS
	TEAM_CREATE_POPUP_OPENED = 'Team create popup opened',
	TEAM_EDIT_POPUP_OPENED = 'Team edit popup opened',
	TEAM_MEMBER_POPUP_OPENED = 'Team member popup opened',
	TEAM_CREATED = 'Team created',
	TEAM_DELETED = 'Team deleted',
	TEAM_MEMBER_CHANGED = 'Team member changed',
	TEAM_PAGE_EDITED = 'Team page edited',

	// SLACK
	SLACK_CHANNELS_SELECTED = 'Slack channels selected',

	// START GENERATIVE_AI DATA_PERFORMANCE_SUMMARY
	/*
		Common subproperties

		type: 'databoard' | 'metric' | 'goal' | 'multiple_metric' | 'performance'
		datasources: datasource name (e.g. GoogleAnalytics), could be multiple
		metrics: metric name, could be multiple
	*/

	DATA_PERFORMANCE_SUMMARY_POPUP_OPENED = 'Performance tooltip viewed',
	/*
		origin: 'designer' | 'designer_datablock' | 'preview_databoard' | 'preview_datablock' | 'databoards' | 'metrics' | 'goals' | 'metrics_detail' | 'home'

		type: from Common subproperties
		datasources: from Common subproperties
		metrics: from Common subproperties
	*/

	DATA_PERFORMANCE_SUMMARY_REFRESHED = 'Performance reload',
	/*
		choice: 'tooltip' | 'performance_summary' | 'datablock'

		type: from Common subproperties
		datasources: from Common subproperties
		metrics: from Common subproperties
	*/

	// END GENERATIVE_AI DATA_PERFORMANCE_SUMMARY

	// GA4 TRANSITION TOOL
	GA4_TRANSITION_POPUP_OPENED = 'GA4 Transition clicked',

	// DATASETS
	NEW_DATASET_INITIATED = 'New dataset initiated',
	NEW_DATASET = 'New dataset',

	// RAW DATA
	METRIC_DATA_RAW_POPUP = 'Metric data raw popup',
	METRIC_DATA_RAW_EXPORT = 'Metric data export',

	// VERIFICATION
	VERIFICATION_ADDED = 'Verification added',
	VERIFICATION_REMOVED = 'Verification removed',

	// AI CHAT
	AI_CHAT_OPENED = 'AIbot_open',
	AI_CHAT_CLOSED = 'AIbot_close',
	AI_BOT_PROMPT_SUBMITTED = 'AIbot_prompt_submitted',

	// COMING SOON WAITLISTS
	COMING_SOON_WAITLIST_AGENTS = 'Coming soon waitlist signup (Agents)',
	COMING_SOON_WAITLIST_MCP_CONNECTORS = 'Coming soon waitlist signup (MCP connectors)',

	// TOURS (blue bubbles)
	BUBBLE_CLIENT_PERFORMANCE_METRIC = 'Bubble Client Performance Metric',
	BUBBLE_CLIENTS_SETUP = 'Bubble Clients Setup',
	BUBBLE_CREATE_A_NEW_SLIDE_REPORT = 'Bubble create a new slide report',
	BUBBLE_FAVORITE_REPORT = 'Bubble favorite report',
	BUBBLE_FIRST_BOARD = 'Bubble First Board',
	BUBBLE_FIRST_BOARD_EDIT = 'Bubble First Board Edit',
	BUBBLE_FIRST_BOARD_SHARE = 'Bubble First Board Share',
	BUBBLE_METRICS_ADD_BLOCK = 'Bubble Metrics Add Block',
	BUBBLE_METRICS_FAVORITES = 'Bubble Metrics Favorites',
	BUBBLE_METRICS_SOURCES = 'Bubble Metrics Sources',
	BUBBLE_PDF_DOWNLOAD_REPORT = 'Bubble pdf download report',
	BUBBLE_REPORT_NOTE = 'Bubble report note',
	BUBBLE_REPORTS_PAGELESS_ADD_BLOCKS = 'Bubble reports pageless add blocks',
	BUBBLE_REPORTS_PAGELESS_ADD_COLUMN = 'Bubble reports pageless add column',
	BUBBLE_REPORTS_PAGELESS_CUSTOMIZE = 'Bubble reports pageless customize',
	BUBBLE_REPORTS_PAGELESS_SHARE = 'Bubble reports pageless share',
	BUBBLE_REPORTS_PAGELESS_VIEW_SWITCH = 'Bubble reports pageless view switch',
	BUBBLE_REPORTS_PRESENT = 'Bubble reports present',
	BUBBLE_SHARE_REPORT = 'Bubble share report',
	BUBBLES_DATE_RANGE_CHANGED = 'Bubbles date range changed',
	BUBBLES_DESIGNER_ADD_TO_LOOP = 'Bubbles designer add to loop',
	BUBBLES_DESIGNER_ADD_TO_REPORT = 'Bubbles designer add to report',
	BUBBLES_DESIGNER_DRAG_AND_DROP = 'Bubbles designer drag and drop',
	BUBBLES_INTRO_DESIGNER_TOUR = 'Bubbles Intro Designer Tour',

	// SEARCH (filter-sort typed filter)
	DATABLOCK_SEARCH = 'Datablock search',
	DATASOURCE_SEARCH = 'Datasource search',
	DIMENSION_SELECT = 'Dimension select',
	METRIC_SEARCH = 'Metric search',
	SOURCE_SEARCH = 'Source search',
	TEMPLATE_SEARCH = 'Template search',

	// INFO POPUP (data status)
	INFO_POPUP_SHOWN = 'InfoPopup_Shown',
	INFO_POPUP_ERROR_SHOWN = 'InfoPopup_ErrorShown',
	INFO_POPUP_RECONNECT = 'InfoPopup_Reconnect',
	INFO_POPUP_REAUTHORIZE = 'InfoPopup_Reauthorize',
	INFO_POPUP_REFETCH = 'InfoPopup_Refetch',

	// OTHER
	USER_DELETED = 'User deleted',
	DESIGNER_BLOCK_REORDER = 'Designer Block reorder',
	SEND_BOARD_TO_CLIENT = 'Send board to Client',
	DATABOARD_REORDER = 'Databoard reorder',
	STREAMING_STARTED = 'Streaming Started',
	CLIENT_KPI_COLUMN_CHANGED = 'Client KPI column changed',
	CLIENT_KPI_COLUMN_SET = 'Client KPI column set',
	CLIENT_KPI_TILE_SELECT_SOURCE = 'Client KPI tile select source',
	CLIENT_KPI_TILE_EDIT = 'Client KPI tile edit',
	CLIENT_KPI_TILE_DELETE = 'Client KPI tile delete',
	CLIENTS_REORDER = 'Clients reorder',
	RELOADED_AFTER_UPDATE = 'Reloaded after update',
	DATABOARD_STREAMING_SETTINGS_AUTOSAVED = 'Databoard Streaming settings autosaved',
	CUSTOM_DATE_PERIOD_PICKER_OPENED = 'Custom date period picker opened',
	GOAL_REORDER = 'Goal reorder',
	REPORT_PDF_DOWNLOAD = 'Report PDF download',
	REPORT_PDF_URL_COPY_PASTE = 'Report PDF url copy/paste',
	METRIC_DELETED = 'Metric deleted',
	CALCULATION_EDITED = 'Calculation edited',
	TAGS_MANAGE = 'Tags manage',
	TAGS_ASSIGNED = 'Tags assigned',
	DATABOARD_WIZARD_METRICS_SUCCESS = 'Databoard Wizard Metrics Success',
	ANNOTATION_CREATED = 'Annotation created',
	DATABOARD_PERMISSIONS_POPUP = 'Databoard permissions popup',
	QUERY_PREVIEWED = 'Query previewed',
	TAGS_FILTERED = 'Tags filtered',
	GOAL_DELETED = 'Goal deleted',
	REPORT_SHOW_PREVIEW = 'Report show preview',
	ONBOARDING_CONNECT_HELP_CONNECTING = 'Onboarding Connect help connecting',
	REQUEST_ACCESS_FORBIDDEN = 'Request access forbidden',
	INTRO_VIDEO = 'Intro video',
	SHOW_UPDATE_INFOLAYER = 'Show update infolayer',
	SHOW_UPDATE_TAKEOVER = 'Show update takeover',
	METRIC_NEW = 'Metric new',

	// METRIC MOVER - legacy metric deletion popups (snake_case names are a product decision)
	METRIC_MOVER_POPUP_SHOWN = 'metric_mover_popup_shown',
	METRIC_MOVER_POPUP_REVIEW = 'metric_mover_popup_review',
	METRIC_MOVER_PUSHAPI_POPUP_SHOWN = 'metric_mover_pushapi_popup_shown',
	METRIC_MOVER_PUSHAPI_REVIEW = 'metric_mover_pushapi_review',
}

export const enum TrackingPage {
	ALERT_CENTER = 'Alert center',
}
